// remove hilighted class from given node
export default node => {
  node.classList.remove('-hilighted')
}



/** WEBPACK FOOTER **
 ** ./src/utils/unhilight_node.js
 **/